import React from 'react'
import { PropertiesListingWrapper } from './styled'
import { Box, ButtonStyled, HeadingStyled, HeadingStyledSm, SpanStyled } from '../../../../components/styled/Elements'
import { useTranslation } from 'react-i18next'
import { LocationPin, PlusIcon, ThreeDots, Thumbnail1 } from '../../../../components/styled/AllImages'
import { PropertyDropdownList } from '../../../../helpers/webConstants'
import CustomDropdown from '../../../../components/common/dropdowns/CustomDropdown'
import ActionDropdown from '../../../../components/common/dropdowns/ActionDropdown'
import PopertiesCards from './popertiesCard'


const PopertiesListing = ({showAll, setShowAll}) => {
    const {t} = useTranslation();
  return (
    <PropertiesListingWrapper>
        
        <Box className='w-100'>
            <PopertiesCards showAll={showAll} setShowAll={setShowAll} />
        </Box>
    </PropertiesListingWrapper>
  )
}

export default PopertiesListing


